import * as React from "react";
import { useContext } from "react";
import { isNil } from "ramda";

import { ExecuteButton } from "affinityForm/components/executeButton";
import { Button, ButtonVariants } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { ButtonGroup } from "affinityUI/form/components";

import { SettingsFormContext } from "../settingsFormContext";

import { SettingsSummary } from "./settingsSummary";

export const SettingsConfirmation: React.FC<{
  onCancel: () => void;
}> = ({ onCancel: handleCancel }) => {
  const formContext = useContext(SettingsFormContext);
  const configuration = formContext?.formData;

  if (!isNil(configuration)) {
    return (
      <Card>
        <SettingsSummary configuration={configuration} formLink=".." />
        <ButtonGroup>
          <Button variant={ButtonVariants.SECONDARY} onClick={handleCancel}>
            Cancel
          </Button>
          <ExecuteButton>Confirm and save</ExecuteButton>
        </ButtonGroup>
      </Card>
    );
  } else {
    return <>Error...</>;
  }
};
